import { RootPage } from '../page';
import $api from '../../api';
import { ChangelogModel, ChangelogsConfig } from '../../models/Gen/BaseModels';
import cme from '../../models/ChangelogModelExtended';
import Pager from '../../components/pager';
import getHashOrDefault from '../../utils/getHashOrDefault';
import languages from '../../utils/languages';
import UrlFilterDescriptor from '../../components/descriptors/urlFilterDescriptor';

class ChangelogsOverviewView extends RootPage {
    constructor() {
        super();
        cme();

        //this.tabsUseHashes = true;

        Pager();
        UrlFilterDescriptor(this);

        this.pageInfo = {};
        this.changelogs = ko.observableArray();

        this.setActiveTab(getHashOrDefault('changelogs'));

        this.config = ko.observable(new ChangelogsConfig());

        this.triggers = [
            { name: 'Once for existing and new users', type: 'onload' },
            { name: 'Once for existing users', type: 'onload-existing' },
            { name: 'Always', type: 'always' },
            { name: 'Manually', type: 'manually' }
        ];
        this.selectedTrigger = ko.computed({
            read: () => {
                var serverTrigger = ko.unwrap(this.config().trigger);

                if (!serverTrigger || ko.unwrap(serverTrigger.type) == 'onload') {
                    return this.triggers[0];
                } else {
                    return this.triggers.filter(i => i.type == ko.unwrap(serverTrigger.type))[0];
                }
            },
            write: (val) => {
                var cfg = this.config();

                cfg.trigger(val);
            }
        });

        this.selectedLanguage = ko.observable(window.auth.project.SupportedLanguages[0]);
        this.supportedLanguages = languages.filter(i => window.auth.project.SupportedLanguages.indexOf(i.alpha2) !== -1);
    }

    onInit() {
        this.setChangelogsFromPagedList(this.getServerSideData('changelogs'));
    }

    setChangelogsFromPagedList(list) {
        var res = [];

        for (var i of list.items) {
            res.push(new ChangelogModel(i));
        }

        this.changelogs(res);
        this.pageInfo = list;
    }

    onAtiveTabChanged(tab) {
        if (tab === 'settings') {
            this.loadConfig();
        }
    }

    loadConfig() {
        $api.changelogs.getConfig({ projectCode: window.auth.project.UniqueCode }, {}, (res) => {
            this.config(new ChangelogsConfig(res));

            if (!this.config().trigger()) {
                this.config().trigger(this.triggers[0]); // manually
            }
        });
    }

    saveConfig() {
        $api.changelogs.saveConfig({ projectCode: window.auth.project.UniqueCode }, this.config().toJS(), () => {
            this.showToast('Changelog settings saved.');
        });
    }

    createChangelog() {
    }

    edit(item) {
        //console.log('ERD', item);
        window.location.href = '/' + auth.project.UniqueCode + '/changelogs/detail/' + item.id();
    }

    remove(item) {
        if (confirm('Really?')) {
            $api.changelogs.remove(
                { projectCode: window.auth.project.UniqueCode, id: ko.unwrap(item.id) },
                {},
                () => {
                    TRACK_EVENT('Changelogs', 'Removed');
                    this.getPage(this.pageInfo.page, this.pageInfo.pageSize);
                    this.showToast('The changelog was removed.');
                }
            );
        }
    }

    getPage(page, pageSize) {
        $api.changelogs.getAll(
            { projectCode: window.auth.project.UniqueCode, page, pageSize },
            {},
            (r) => {
                this.setChangelogsFromPagedList(r);
            }
        );
    }

    bindLocalizableProp(observable) {
        return ko.computed({
            read: () => {
                var val = observable();
                if (!val) {
                    return undefined;
                }

                return ko.unwrap(observable()[this.selectedLanguage()]);
            },
            write: (val) => {
                var curV = observable();

                if (!curV) {
                    curV = {};
                }

                curV[this.selectedLanguage()] = val;

                observable(curV);
            }
        });
    }

    getSomeLocalizedValue(obs) {
        if (obs('en')()) return obs('en');

        for (const lng of this.supportedLanguages) {
            if (obs(lng.alpha2)()) {
                return obs(lng.alpha2);
            }
        }
    }
}

export default ChangelogsOverviewView;